import { FC } from 'react'
import styled from 'styled-components'

import { Clock, TypeStyleBodySmall, fromMd } from '@syconium/little-miss-figgy'

import { useFeatureFlag } from '../../../../../../app/_providers/ExperimentationProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { ProductDetailsContainer } from '../../contexts/ProductDetailsContainer'
import { EmbroiderySection } from '../EmbroiderySection'

import { ColorSection } from './ColorSection'
import { FitsSection } from './FitsSection'
import { SizesSection } from './SizesSection'

/**
 * The attribute selectors that are displayed for the current product.
 */
export const GarmentAttributes: FC = () => {
  const {
    isProductEmbroiderable,
    isProductOnWaitlist,
    colorGroups,
    portalColorGroups,
    selectedVariant,
  } = ProductDetailsContainer.useContainer()
  const selectedVariantHasLowInventory = Boolean(selectedVariant?.isLowInventory)

  const lowStockMessageTestDecision = useFeatureFlag<
    'no-low-stock-message' | 'yes-low-stock-message'
  >({
    key: 'low-stock-a-b-test',
    controlVariant: 'no-low-stock-message',
    ifAccessedPriorToDecisionInitialization: 'return-null-while-pending',
    skip: !selectedVariantHasLowInventory || selectedVariant?.soldOut,
  })
  const translations = useTranslation()
  return (
    <>
      <ColorSection
        colorGroups={colorGroups}
        allowPriceBasedGrouping={portalColorGroups.length === 0}
      />
      {lowStockMessageTestDecision === 'yes-low-stock-message' ? (
        <LowInventoryTypography>
          <Clock />
          {translations.pages.product.lowInventoryWarning}
        </LowInventoryTypography>
      ) : null}
      <SizesSection />
      <FitsSection />
      <EmbroiderySection
        isPortalColorSelected={false}
        embroiderable={isProductEmbroiderable && !isProductOnWaitlist}
      />
    </>
  )
}

const LowInventoryTypography = styled(TypeStyleBodySmall)`
  color: ${o => o.theme.color.text.caution.on.background};
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  margin: ${o => o.theme.spacing(4, 4)};
  ${fromMd} {
    margin: ${o => o.theme.spacing(4, 0)};
  }
`
